if (!customElements.get('product-discount-code')) {
  customElements.define(
    'product-discount-code',
    class ProductDiscountCode extends HTMLElement {
      constructor() {
        super();

        this.variantIdChangedUnsubscriber = undefined;
        this.discountedPriceElem = undefined;
        this.originPriceElem = undefined;

        this.copyCode = this.copyCode.bind(this); // Bind `this` to make sure `copyCode` works correctly in event listeners
      }

      connectedCallback() {
        this.savingsAmountElem = this.querySelector('.discount-code__savings-amount');
        this.codeTextElem = this.querySelector('.discount-code__code-text');
        this.codeContainer = this.querySelector('.discount-code__code');
        this.copyBtn = this.querySelector('.discount-code__code-copy-btn');

        if (this.copyBtn) {
          // Store the original icon HTML
          this.originalIconHTML = this.copyBtn.innerHTML;
          this.copyBtn.addEventListener('click', this.copyCode);
        }

        const discountPercent = this.savingsAmountElem?.dataset.percent;

        if (discountPercent && this.savingsAmountElem) {
          this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variantPrice = event.data.variant.price;

            if (variantPrice) {
              const savingsAmount = variantPrice - (variantPrice * (100 - discountPercent)) / 100;
              this.savingsAmountElem.innerHTML = Shopify.formatMoney(savingsAmount);
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.variantIdChangedUnsubscriber) {
          this.variantIdChangedUnsubscriber();
        }
      }

      copyCode(event) {
        event.preventDefault();

        const failedCodeCopiedText = this.dataset.failedCodeCopiedText;

        navigator.clipboard
          .writeText(this.dataset.code)
          .then(() => {
            // Change icon to checkmark with thinner stroke
            this.copyBtn.innerHTML = `
              <svg width="20" height="20" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" style="display: block;">
                <path d="M1.5 6L6 10.5L14.5 2" stroke="#1d1d1d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            `;
            this.codeContainer.classList.add('discount-code__code--copied');

            // Reset after 2 seconds
            setTimeout(() => {
              this.copyBtn.innerHTML = this.originalIconHTML;
              this.codeContainer.classList.remove('discount-code__code--copied');
            }, 2000);
          })
          .catch((err) => {
            console.log(failedCodeCopiedText, err);
            // Show error state
            this.codeContainer.classList.add('discount-code__code--error');

            // Reset after 2 seconds
            setTimeout(() => {
              this.codeContainer.classList.remove('discount-code__code--error');
            }, 2000);
          });
      }
    }
  );
}
